import { Box } from "@mui/material";
import React from "react";
import { path } from "src/constants/path";
import {
  allowedToDeleteEntity,
  allowedToReadEntity,
  allowedToUpdateEntity,
} from "src/constants/role";
import { dataStateType } from "src/constants/status";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useAuth from "src/hooks/useAuth";
import { iotPartnerColumns as columns } from "../../Helper";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { isOpenPopup } from "src/utils/isOpenPopup";

const GetIotPartnerColumns = ({ handleDelete, handleOpenPopup, status }) => {
  const { auth } = useAuth();
  const history = useHistory();
  const permissionsAccessControl = useGetPermissionAccessControl();
  const showDeviceIotPartner = (iotPartner) => {
    history.push(`${path.flfDevice}?page=1&iotPartnerId=${iotPartner.id}`);
  };
  const actionCol = {
    key: "actions",
    label: "Actions",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToReadEntity(auth?.permissions, permissionsAccessControl) && (
          <button
            className="btn btn-success"
            onClick={() => {
              showDeviceIotPartner(item);
            }}
          >
            <i className="bx bx-show"></i>
          </button>
        )}
        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <button
            className="btn btn-warning"
            onClick={() => {
              handleOpenPopup(isOpenPopup, item);
            }}
          >
            <i className="bx bx-edit"></i>
          </button>
        )}
        {allowedToDeleteEntity(auth?.permissions, permissionsAccessControl) && (
          <button className="btn btn-danger" onClick={() => handleDelete(item)}>
            <i className="bx bx-trash"></i>
          </button>
        )}
      </Box>
    ),
  };

  if (status === dataStateType.ACTIVE) {
    return [...columns, actionCol];
  }

  return columns;
};

export default GetIotPartnerColumns;
